<template>
  <div>
    <DemoForm/>
  </div>
</template>

<script>
import DemoForm from '@/components/demo'
export default {
  components: {
    DemoForm,
  },
}
</script>

<style>
</style>
